const values = {
  OPTION: 'o',
  VALIDATED: 'v',
  PACKAGE_UPGRADE: 'p',
  ADDITIONAL_SERVICE: 'a',
  PICK_YOUR_ROOM: 'y',
  UPGRADE_ROOM: 'r',
  UNKNOWN: 'u',
  CART: 'c',
  SERVICES_IN_OPTION: 's',
};

const reverseValues = Object.keys(values).reduce((acc, key) => {
  acc[values[key]] = key;
  return acc;
}, {});

export function getCodeFromStatus(status) {
  return values[status] || values.UNKNOWN;
}

export function getStatusFromCode(code) {
  return reverseValues[code] || null;
}
